export type SearchParamDefault = Record<string, string | number | boolean | undefined>;
export type SearchParams<T extends SearchParamDefault = SearchParamDefault> = {
  [K in keyof T]: T[K];
};

export function paramsToString(params: SearchParams) {
  const queryString = new URLSearchParams();
  Object.entries(params)
    .filter(([_, value]) => Boolean(value))
    .forEach(([key, value]) => queryString.append(key, String(value)));

  // console.log(queryString.toString() ? `?${queryString}` : '');

  return queryString.toString() ? `?${queryString}` : '';
}
